import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { GetFolderPermissionsEwsPermissionInfo } from '../../../../api/types.gen';
import { CreatePermissionLevel } from './PermissionEnums';

interface CreatePermissionCellProps {
  cellContext: CellContext<GetFolderPermissionsEwsPermissionInfo | null, CreatePermissionLevel>;
}

export function CreatePermissionCell({ cellContext }: CreatePermissionCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const value = cellContext.getValue();

  switch (value) {
    case CreatePermissionLevel.CreateItemsAndSubFolders:
      return <>{t('createPermissionsItemsSubfolders')}</>;
    case CreatePermissionLevel.CreateItems:
      return <>{t('createPermissionsItems')}</>;
    case CreatePermissionLevel.CreateSubFolders:
      return <>{t('createPermissionsSubfolders')}</>;
    default:
      return <>{t('createPermissionsNone')}</>;
  }
}
